export default __webpack_public_path__ + "static/media/grafema_design-factory-kitchen-pictograms_09.785ed37e.jpg";